<div class="box">
    <div class="box-content">
        <mat-spinner *ngIf="isLoading; else boxContent" [diameter]="30"></mat-spinner>
    </div>
</div>

<ng-template #boxContent>
    <button *ngIf="!isLoading && annualPlan && weeks"
            mat-mini-fab
            color="none"
            class="more-button float-right mr-50"
            [matTooltip]="'AnnualPlan' | translate"
            [routerLink]="'/' + this.organization?.code + '/athletes/' + athleteUser?.id + '/plans/' + annualPlan.id">
        <mat-icon color="primary">zoom_in</mat-icon>
    </button>
    <button
        mat-mini-fab
        color="none"
        class="more-button float-right"
        [matTooltip]="'AnnualPlanList' | translate"
        [routerLink]="'/' + organization?.code + '/athletes/' + athleteUser?.id + '/plans'">
        <mat-icon color="primary">link</mat-icon>
    </button>

    <div fxLayout="row" fxLayoutAlign="start" >
        <div class="annual-plan-container">
            <app-annual-plan-graph *ngIf="!isLoading"
                                   [organization]="organization"
                                   [annualPlan]="annualPlan"
                                   [weeks]="weeks"
                                   [annualPlanPhases]="annualPlanPhases"
                                   [annualPlanMacroCycles]="annualPlanMacroCycles"
                                   viewMode="small"
                                   [showMonths]="true"
            ></app-annual-plan-graph>
        </div>
    </div>
</ng-template>

